import React from "react";
import { Box } from "@mui/material";
import "./index.css";
import CurrencyFormater from "../../../../utils/CurrencyFormater";
import { useNavigate } from "react-router-dom";
import trimSentence from "../../../../utils/trimSentence";
import { useSelector } from "react-redux";

const TxnStatusCard = (props) => {
  const navigate = useNavigate();
  const services = useSelector((state) => state.refreshToken.services);
  return (
    <>
      <div className="flex w-5/6 h-full flex-col bg-white rounded-4xl items-center justify-between">
        <div className="w-full flex flex-col gap-2 3xl:gap-4 6xl:gap-6">
          <div className="flex flex-col gap-6 p-4 mt-4 pb-4">
            <div className="text-2xl 4xl:text-4xl font-semibold text-[#27B882] w-full">
              ₹ {CurrencyFormater(props.amount)}
            </div>
          </div>
          <Box className="dashedLine"></Box>
          <div
            className="mt-6 text-black font-semibold text-xl 3xl:text-2xl 5xl:text-3xl 6xl:text-4xl
            capitalize antialiased truncate ..."
          >
            {props.name}
          </div>
        </div>
        {props.status === "Y" || props.status === "P" ? (
          <div
            className="w-full h-[30%] xl:h-[25%] text-white rounded-4xl flex justify-evenly items-center"
            style={{
              backgroundColor:
                props.status === "Y" || props.status === "P"
                  ? "#7FB085"
                  : "#9F5353",
            }}
          >
            {services.includes("Settle_txn") && (
              <>
                <div
                  className={`flex flex-col hover:opacity-75 cursor-pointer w-1/3 gap-4 items-center justify-center`}
                  onClick={() =>
                    navigate(`/settlement_required/vendor_transactions`)
                  }
                >
                  <div className="w-2/6 flex justify-center">
                    <img
                      width={"70%"}
                      src={require("../../../../assets/CreateTransactionIcons/Settle.png")}
                      alt=""
                      srcSet=""
                    />
                  </div>
                  <p>
                    Settle <br /> transaction
                  </p>
                </div>
                <div className="h-4/5 w-0.5 bg-gray-300" />
              </>
            )}
            {!(props.txn_len > 1) && (
              <>
                <div
                  className={`flex flex-col hover:opacity-50 cursor-pointer w-1/3 gap-2 items-center justify-center`}
                  onClick={() => navigate(`/vendor/txn/${props.txn}`)}
                >
                  <div className="w-2/6 flex justify-center">
                    <img
                      width="70%"
                      src={require("../../../../assets/CreateTransactionIcons/View details.png")}
                      alt=""
                      srcSet=""
                      className=""
                    />
                  </div>
                  <p>
                    View transaction <br /> details
                  </p>
                </div>
                <div className="h-4/5 w-0.5 bg-gray-300" />
              </>
            )}
            <div
              className={`flex flex-col hover:opacity-50 cursor-pointer w-1/3 gap-2 items-center justify-center`}
              onClick={() => navigate(`/vendor_transactions`)}
            >
              <div className="w-2/6 flex justify-center">
                <img
                  width={"70%"}
                  src={require("../../../../assets/CreateTransactionIcons/Dashboard.png")}
                  alt=""
                  srcSet=""
                  className=""
                />
              </div>
              <p>
                Go to <br /> dashboard
              </p>
            </div>
          </div>
        ) : (
          <div
            className="w-full h-[30%] xl:h-[25%] text-white rounded-4xl bg-[#7fb085] flex justify-evenly items-center cursor-pointer"
            style={{
              backgroundColor:
                props.status === "Y" || props.status === "P"
                  ? "#7FB085"
                  : "#9F5353",
            }}
          >
            {!(props.txn_len > 1) && (
              <>
                <div
                  className={`flex flex-col ${props.txn_len > 1 ? "w-1/2" : "w-1/3"
                    } gap-2 items-center justify-center`}
                  onClick={() => navigate(`/vendor/txn/${props.txn}`)}
                >
                  <div className="w-2/6 flex justify-center">
                    <img
                      width="70%"
                      src={require("../../../../assets/CreateTransactionIcons/View details.png")}
                      alt=""
                      srcSet=""
                    />
                  </div>
                  <p>
                    View transaction <br /> details
                  </p>
                </div>
                <div className="h-4/5 w-0.5 bg-gray-300" />
              </>
            )}
            {/* <div className="h-4/5 w-0.5 bg-gray-300" /> */}
            <div
              className={`flex flex-col w-2/6 gap-2 items-center justify-center`}
              onClick={() => navigate(`/vendor_transactions`)}
            >
              <div className="w-2/6 flex justify-center">
                <img
                  width="70%"
                  src={require("../../../../assets/CreateTransactionIcons/Dashboard.png")}
                  alt=""
                  srcSet=""
                />
              </div>
              <p>
                Go to <br /> dashboard
              </p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default TxnStatusCard;
